export const KREA_3_MODEL = 'krea/v3/text-to-image';
export const KREA_3_DEFAULT_REASONING_LEVEL = 'medium';
/** Reasoning levels Fal only accepts on the edit endpoint. */
export const KREA_3_EDIT_ONLY_REASONING_LEVELS = ['high', 'ultra'];
